import { getRandomElement } from './utils';
import { bgColors } from './constants';

document.addEventListener("DOMContentLoaded", function() {
    let newBgColor = getRandomElement(bgColors, window.store.state.currentBgColor);
    document.documentElement.style.setProperty("--bg-color", newBgColor);
    window.store.setCurrentBgColor(newBgColor)
});

